import { createSelector } from '@reduxjs/toolkit';

import { getLoggedInUsersOrganizationMaterialSet } from './getLoggedInUsersOrganizationMaterialSetSelector';

export const getPlateListsRecord = createSelector(
  getLoggedInUsersOrganizationMaterialSet,
  (materialSet) => materialSet?.plateLists,
);

export const getPlateLists = createSelector(getPlateListsRecord, (plateLists) => Object.values(plateLists ?? {}));
